import React, { Component } from 'react';

import { Button, Container } from 'reactstrap';
import CreateDmxDeviceProfileForm from '../../components/Forms/CreateDmxDeviceProfileForm';

class NewDmxDeviceProfile extends Component {
  goBack(event) {
    event.preventDefault();
    this.props.history.push('/dmxDeviceProfiles');
  }

  render() {
    return (
      <div className="user-management">
        <Container fluid>
          <Button className="btn btn-primary waves-effect waves-light usersButtons" onClick={(event) => this.goBack(event)}>
            <i className="fas fa-arrow-left"></i>
          </Button>
          <CreateDmxDeviceProfileForm />
        </Container>
      </div>
    );
  }
}

export default NewDmxDeviceProfile;
